
class ProductSubscription extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.radios = this.querySelectorAll('input[type=radio]');
            this.select = this.querySelector('[name=selling_plan]');
            this.ATCBTNTEXT = this.querySelector('product-form-component dynamic-price');
            this.main();
          }
          main() {
            this.radios.forEach((radio) => {
              radio.addEventListener('change', () => {
                this.ATCBTNTEXT.textContent = radio.dataset.price;
                if (radio.value == 'one_time') {
                  this.select.disabled = true;
                } else {
                  this.select.disabled = false;
                }
              });
            });
          }
        }
        if (!customElements.get('product-subscription')) customElements.define('product-subscription', ProductSubscription);
